import { Component, inject, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgIf } from '@angular/common';

import { LoadingService } from './services/loading.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { HttpServiceService } from './services/http-service.service';
import { LocalStorageService } from './services/local-storage.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatProgressBarModule, NgIf],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'property_handling';
  loadingService = inject(LoadingService); 
  
  constructor(){
   
  }
  
}
